import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Container = styled.div `
  display: flex;
  align-items: center;
  flex-direction: row;
  user-select: none;

  ${({ themeOption }) => {
    switch (themeOption) {
        case 'light':
            return css `
          ${setCssVar('accentColor', brand.green)};
          ${setCssVar('fgColor', brand.black)};
        `;
        case 'burgundy':
            return css `
          ${setCssVar('accentColor', brand.burgundy)};
          ${setCssVar('fgColor', brand.black)};
        `;
        case 'whiteBurgundy':
            return css `
          ${setCssVar('accentColor', brand.burgundy)};
          ${setCssVar('fgColor', brand.black)};
        `;
        case 'dark':
            return css `
          ${setCssVar('accentColor', brand.green)};
          ${setCssVar('fgColor', brand.white)};
        `;
        case 'darkBurgundy':
            return css `
          ${setCssVar('accentColor', brand.lightBurgundy)};
          ${setCssVar('fgColor', brand.white)};
        `;
    }
}}
`;
const SlideButton = styled.button `
  display: inline-flex;
  background: none;
  border: 0;
  color: ${cssVar('fgColor')};
  margin: 0;
  padding: 18px 0;
  place-content: center;
  place-items: center;
  transition: background-color 0.15s ease-out;

  & + & {
    margin: 0 0 0 8px;
  }

  &::before {
    content: '';
    background: ${cssVar('fgColor')};
    height: 4px;
    transition: background-color 0.15s ease-out;
    width: 40px;
  }

  &:not(:disabled) {
    &:focus {
      outline: none;
    }

    &:focus,
    &:hover {
      &::before {
        background: ${cssVar('accentColor')};
      }
    }
  }

  &:disabled {
    &::before {
      background: ${cssVar('accentColor')};
    }
  }
`;
const ControlButton = styled.button `
  position: relative;
  display: inline-flex;
  background: none;
  border: 1px solid ${cssVar('fgColor')};
  border-radius: 50%;
  color: ${cssVar('fgColor')};
  height: 40px;
  margin: 0 0 0 8px;
  padding: 0;
  place-content: center;
  place-items: center;
  width: 40px;
  transition: border-color 0.15s ease-out, opacity 0.15s ease-out;

  &:not(:disabled) {
    &:focus {
      outline: none;
    }

    &:focus,
    &:hover {
      border-color: ${cssVar('accentColor')};
    }
  }

  &:disabled {
    opacity: 0.5;
  }

  @media ${until(Device.Tablet)} {
    margin: 0 8px 0 0;
  }
`;
const ControlIcon = styled.span `
  color: ${cssVar('fgColor')};
  height: 14px;
  width: 14px;
`;
const ControlProgressButton = styled(ControlButton) `
  border: 0;
`;
const ControlProgress = styled.svg `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  color: ${cssVar('accentColor')};
  height: 100%;
  width: 100%;
`;
const ControlProgressCircle = styled(m.circle) `
  stroke-dasharray: var(--circumference) var(--circumference);
  transform: rotate(-90deg);
  transform-origin: center center;
`;
const SrOnly = styled.span `
  ${srOnly}
`;
export default {
    Container,
    ControlButton,
    ControlIcon,
    ControlProgress,
    ControlProgressButton,
    ControlProgressCircle,
    SlideButton,
    SrOnly,
};
